import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ILocaleInfo } from '../../_shared/locale/locale.model';
import { LocaleService } from '../../_shared/locale/locale.service';
import { SpinnerService } from '../../_shared/services/spinner/spinner.service';
import { Store } from '@ngrx/store';
import { AppState, LocaleState } from '../../_store/app-state.model';
import { AppSelectors } from '../../_store/selector-types';
import { environment } from '../../../environments/environment';
import { cultureCodes } from '../../_shared/constants/constants';

@Component({
    selector: 'sd-language-selector',
    templateUrl: './language-selector-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class LanguageSelectorModalComponent {
  locale$: Observable<string>;
  localeState$: Observable<LocaleState>;
  globalLocales = [
    { name: 'English', code: 'en' },
    { name: 'Français', code: cultureCodes.French },
    { name: 'Español', code: cultureCodes.Spanish },
  ]

  constructor(
    private store$: Store<AppState>,
    private localeService: LocaleService,
    public dialogRef: MatDialogRef<LanguageSelectorModalComponent>,
    private spinner: SpinnerService
  ) {
      // this.locale$ = this.localeService.locale$.pipe(map(loc => loc));
      this.localeState$ = this.store$.select(AppSelectors.selectLocaleState);
  }

  localeAvailable(locale: string) {
    return environment.availableLocales.indexOf(locale) != -1;
  }

  setLocale(localeState: LocaleState, localeCode: string) {
    this.spinner.show();
      
    const localeInfo: ILocaleInfo = {
      locale: localeCode,
      userDefaultLocale: localeState.userDefaultLocale
    };
    this.localeService.registerCulture(localeInfo);
    window.location.reload();
  }

  closeModal() {
    this.dialogRef.close();
  }
}
